import { render, staticRenderFns } from "./WiseForms.vue?vue&type=template&id=1e81d455&scoped=true&"
import script from "./WiseForms.vue?vue&type=script&lang=js&"
export * from "./WiseForms.vue?vue&type=script&lang=js&"
import style0 from "./WiseForms.vue?vue&type=style&index=0&id=1e81d455&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e81d455",
  null
  
)

export default component.exports